module.exports = __webpack_public_path__ + "img/backAudit.5dfb2f80.png";